import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as qs from 'query-string';
import { withRouter } from 'react-router-dom';
import {  fetchFichasVenta, fetchFichaVenta, loadFichasVenta, fetchHistorialFDV, clearProformas } from '../../actions';
import PageHeader from '../../components/PageHeader';
import NuevaFichaVenta from '../modals/NuevaFichaVenta';
import BuscarFicha from '../DetalleFichaVenta/BuscarFicha';
import toggleDiv from '../../utils/toggleDiv';
import Alert from '../../components/Alert';

class ProformaFichaVenta extends Component {
  constructor(props) {
    super(props);

    const params = qs.parse(this.props.location.search);
    const modalOpen = params.proforma ? 'nueva-fdv' : ''; //Req - 90917_L_Absorcion_Legados_Fase_2 - antes validaba cliente

    this.state = {
      searchInput: '',
      typeSearch: 'nfdv',
      alertErrorOpen: false,
      modalOpen,
      idFichaVenta: ''
    };

    this.loadPage = this.loadPage.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', toggleDiv, true);
    this.loadPage(0);
  }

  loadPage(tipo) {
    const { id } = this.props.match.params;
    this.setState({ idFichaVenta: id });
    this.props.fetchFichaVenta(id);
    this.props.fetchHistorialFDV(id);
  }

  closeModal = () => this.setState({ modalOpen: '' })
  openModal = (modal) => {
    this.setState({ modalOpen: modal });
  }
  onChangeInput = e => this.setState({ [e.target.name]: e.target.value });

  searchFDV = () => {
    this.props.loadFichasVenta();
    this.props.clearProformas();
    const { searchInput, typeSearch } = this.state;
    this.props.fetchFichasVenta('', '1', '1', typeSearch, searchInput)
      .then(() => {
       // const fdvID = this.props.fichasVenta.fichaVentaResponse[0].numFichaVtaVeh;
       // this.props.history.push(`/fichas-venta/${fdvID}`);
       // window.location.reload();
      });
  }

  render() {
    return (
      <div>
        <PageHeader title='Fichas de venta' openModal={this.openModal} buttonName='Nueva ficha de venta' modalName='nueva-fdv' />
        {
          this.state.modalOpen === 'nueva-fdv' &&
            <NuevaFichaVenta
              querys={qs.parse(this.props.location.search)}
              closeModal={this.closeModal}
            />
        }
        <BuscarFicha
          searchFDV={this.searchFDV}
          typeSearch={this.state.typeSearch}
          selectName='typeSearch'
          inputName='searchInput'
          inputValue={this.state.searchInput}
          onChangeInput={this.onChangeInput}
        />


          {
            this.props.fichasVenta && this.props.fichasVenta.error ?
              <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                <p>Hubo un error con el servicio de listar fichasVenta</p>
              </Alert> : null
          }

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    fichasVenta: state.fichasVenta
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchFichasVenta,
    fetchFichaVenta,
    loadFichasVenta,
    clearProformas,
    fetchHistorialFDV
  })(ProformaFichaVenta));



// WEBPACK FOOTER //
// ./src/pages/ProformaFichaVenta/ProformaFichaVenta.js